export default {
	name: "English",

};



// WEBPACK FOOTER //
// ./lib/locales/en.js